import React from 'react';
import classNames from 'classnames/bind';
import { S7, S7Circle, S7Profi, S7ProfiCircle, S7Shop, S7Travel } from "../../../../../icons";
import { themes } from '../../../constants';
import styles from '../MobileMenuCanary.css';
var cx = classNames.bind(styles);
export var Icon = function Icon(_ref) {
  var theme = _ref.theme,
      isMobile = _ref.isMobile;

  switch (theme) {
    case themes.b2b:
      return isMobile ? /*#__PURE__*/React.createElement(S7ProfiCircle, {
        height: 32,
        width: 32
      }) : /*#__PURE__*/React.createElement(S7Profi, {
        height: 32,
        width: 100
      });

    case themes.shop:
      return /*#__PURE__*/React.createElement("div", {
        className: cx('shop')
      }, /*#__PURE__*/React.createElement(S7Shop, {
        height: 32,
        width: 100
      }));

    case themes.travel:
      return /*#__PURE__*/React.createElement(S7Travel, {
        height: 32,
        width: 85
      });

    default:
      return isMobile ? /*#__PURE__*/React.createElement(S7Circle, {
        height: 32,
        width: 32
      }) : /*#__PURE__*/React.createElement(S7, {
        height: 32,
        width: 100
      });
  }
};